var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-button-pdf"},[_c('button',{class:`btn btn-lg ${_vm.color} waves-effect waves-light`,attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }